import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import '../assets/styles/Main.scss';
import profile from '../assets/images/profile1.png';

const LINKEDIN_URL = 'https://www.linkedin.com/in/jungwoo-ryu/';

function Main() {

  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
          <img src={profile} alt="Avatar" />
        </div>
        <div className="content">
          <div className="social_icons">
            <a href="https://github.com/jungwoo-ryu" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href={LINKEDIN_URL} target="_blank" rel="noreferrer"><LinkedInIcon/></a>
            <a href="mailto:jryu1521@gmail.com" rel="noreferrer"><EmailIcon/></a>
            <a href="tel:+16082093712" rel="noreferrer"><PhoneIcon/></a>
          </div>
          <h1>Jungwoo (Ken) Ryu</h1>
          <p className="role-line">Aspiring AX / AI Engineer</p>
          <p className="intro-bio">
            Aspiring AX/AI Engineer with a strong foundation in software engineering and practical experience building AI-powered systems.
            Skilled in backend development, API design, LLM application setup, prompt engineering, and vector retrieval pipelines.
            I am interested in building practical AI systems that improve real-world products and workflows—with a focus on LLM applications,
            RAG systems, backend engineering, and product-driven AI development.
          </p>

          <div className="mobile_social_icons">
            <a href="https://github.com/jungwoo-ryu" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href={LINKEDIN_URL} target="_blank" rel="noreferrer"><LinkedInIcon/></a>
            <a href="mailto:jryu1521@gmail.com" rel="noreferrer"><EmailIcon/></a>
            <a href="tel:+16082093712" rel="noreferrer"><PhoneIcon/></a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;